import Slider3 from './Slider3'
export default Slider3
